export const styles = {
  listItemButton: {
    border: "2px solid #ececec",
    borderRadius: "8px",
    mb: "8px",
  },
  avatar: {
    width: "72px",
    height: "72px",
    mr: "12px",
    borderRadius: "8px",
  },
};
